(() => {
  const mounted = new WeakMap();
  function init(root) {
    if (mounted.has(root)) return;
    const abort = new AbortController(), options = { signal: abort.signal };
    const list = root.querySelector('[data-pf-tp-list]');
    const items = [...list.querySelectorAll('[data-pf-tp-item]')];
    const perPage = Math.max(1, Number(list.dataset.pfTpPerpage) || 3);
    const pages = Math.ceil(items.length / perPage);
    const prev = root.querySelector('[data-pf-tp-prev]'), next = root.querySelector('[data-pf-tp-next]');
    let page = 0;
    const render = () => {
      items.forEach((item, i) => { item.hidden = Math.floor(i / perPage) !== page; });
      prev.disabled = page === 0; next.disabled = pages === 0 || page >= pages - 1;
      root.querySelector('.pf-tp-pagination').hidden = pages <= 1;
    };
    prev.addEventListener('click', () => { if (page > 0) { page--; render(); } }, options);
    next.addEventListener('click', () => { if (page < pages - 1) { page++; render(); } }, options);
    const box = root.querySelector('[data-pf-tp-lb]'), image = box.querySelector('img');
    const closeButton = box.querySelector('[data-pf-tp-lb-close]');
    let lastFocus, previousOverflow;
    const close = () => {
      if (box.hidden) return;
      box.hidden = true; box.classList.remove('is-open'); image.removeAttribute('src');
      document.body.style.overflow = previousOverflow;
      if (lastFocus?.isConnected) lastFocus.focus();
    };
    root.addEventListener('click', e => {
      const photo = e.target.closest('[data-pf-tp-photo]');
      if (!photo) return;
      lastFocus = photo; previousOverflow = document.body.style.overflow;
      image.src = photo.dataset.pfTpPhoto; image.alt = photo.getAttribute('aria-label');
      box.hidden = false; box.classList.add('is-open'); document.body.style.overflow = 'hidden'; closeButton.focus();
    }, options);
    closeButton.addEventListener('click', close, options);
    box.addEventListener('click', e => { if (e.target === box) close(); }, options);
    box.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'Tab') { e.preventDefault(); closeButton.focus(); }
    }, options);
    document.addEventListener('shopify:block:select', e => {
      const index = items.findIndex(item => item.dataset.blockId === e.detail.blockId);
      if (index >= 0) { page = Math.floor(index / perPage); render(); }
    }, options);
    mounted.set(root, () => { close(); abort.abort(); mounted.delete(root); });
    render();
  }
  const timers = new WeakMap();
  function initFlash(root) {
    if (timers.has(root)) return;
    const date = root.querySelector('[data-pf-date]');
    const timer = root.querySelector('.pf-flash-timer');
    if (!timer) return;
    let end = null;
    const nextLocalMidnight = now => {
      const value = new Date(now);
      value.setHours(24, 0, 0, 0);
      return value;
    };
    const setDeadline = now => {
      end = nextLocalMidnight(now);
      if (date) date.textContent = end.toLocaleDateString('es-ES', { weekday:'long', month:'short', day:'numeric' });
    };
    const tick = () => {
      const now = new Date();
      if (!end || now >= end) setDeadline(now);
      const seconds = Math.min(86399, Math.max(0, Math.floor((end - now) / 1000)));
      timer.hidden = false;
      const values={d:Math.floor(seconds/86400),h:Math.floor(seconds/3600)%24,m:Math.floor(seconds/60)%60,s:seconds%60};
      for(const [unit,value] of Object.entries(values))root.querySelector('[data-pf="'+unit+'"]').textContent=String(value).padStart(2,'0');
    };
    setDeadline(new Date());
    timers.set(root,setInterval(tick,1000));tick();
  }
  function scan(scope) { scope.querySelectorAll('[data-pv-reviews]').forEach(init); scope.querySelectorAll('[data-pv-flash]').forEach(initFlash); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>scan(document)); else scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
  document.addEventListener('shopify:section:unload',e=>{
    e.target.querySelectorAll('[data-pv-reviews]').forEach(root=>mounted.get(root)?.());
    e.target.querySelectorAll('[data-pv-flash]').forEach(root=>{clearInterval(timers.get(root));timers.delete(root);});
  });
})();
